import { PlatformsAuthEvent, PlatformsAuthLoginSuccessEvent } from '~/types';

export function isAuthServiceSSOLoginSuccess(
  evnt: PlatformsAuthEvent
): evnt is PlatformsAuthLoginSuccessEvent {
  return evnt.type === 'authservice-sso-login-success';
}
